import { Pipe, PipeTransform } from '@angular/core';
import { cnpj, cpf } from 'cpf-cnpj-validator';

@Pipe({
  name: 'cpfCnpjFormat'
})
export class CpfCnpjFormatPipe implements PipeTransform {
  transform(value: string | number): string {
    value = String(value);

    if (!value) { return value; }

    if (value.length === 11) {
      return cpf.format(value);
    }

    if (value.length === 14) {
      return cnpj.format(value);
    }

    return value;
  }
}
